const ROOT                = "/api";
const VERSION             = "v1";
const BASE                = ROOT + "/" + VERSION;
const EVENT_PREFIX        = "/events";
const IDENTITY_PREFIX     = "/identity";
const CONTRIBUTION_PREFIX = "/contribution";
const MEDIA_PREFIX = "/media";

export const ApiRoutes = {
  Events      : {
    Create       : BASE + EVENT_PREFIX,
    Delete       : BASE + EVENT_PREFIX + "/{eventId}",
    Get          : BASE + EVENT_PREFIX + "/{eventId}",
    GetAll       : BASE + EVENT_PREFIX,
    GetByPublicId: BASE + EVENT_PREFIX + "/published/{publicId}",
    Update       : BASE + EVENT_PREFIX + "/{eventId}"

  },
  Identity    : {
    Login   : BASE + IDENTITY_PREFIX + "/login",
    Refresh : BASE + IDENTITY_PREFIX + "/refresh",
    Register: BASE + IDENTITY_PREFIX + "/register"
  },
    Contribution: {
        GetAll: BASE + CONTRIBUTION_PREFIX + "/get-all/{eventId}",
        Upload: BASE + CONTRIBUTION_PREFIX + "/upload",
        Count: BASE + CONTRIBUTION_PREFIX + "/count/{eventId}",
        Exists: BASE + CONTRIBUTION_PREFIX + "/exists/{cId}",
        Get: BASE + CONTRIBUTION_PREFIX + "/{cId}"
    },
    Media: {
        Get: BASE + MEDIA_PREFIX + "/{mId}"
    }

};
